import { CustomNextImage as Image } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Col, Container, IconButton, Row } from '@crehana/ui';

import BG_DESKTOP from './assets/images/bg-desktop.png';
import BG_TABLET from './assets/images/bg-tablet.png';
import {
  FormWrapper,
  GradientWrapper,
  StyledWrapper,
} from './B2CLayout.styles';
import { CrehanaLogos } from './components';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { B2CLayoutProps } from './types';

export const B2CLayout: React.FC<React.PropsWithChildren<B2CLayoutProps>> = ({
  onBack,
  children,
}) => (
  <StyledWrapper className="relative w-full h-full text-white">
    <div className="relative hidden md:block">
      <Image
        src={BG_DESKTOP}
        alt="Crehana"
        placeholder="blur"
        layout="fill"
        objectFit="cover"
      />
    </div>
    <div className="relative hidden sm:block md:hidden">
      <Image
        src={BG_TABLET}
        alt="Crehana"
        placeholder="blur"
        layout="fill"
        objectFit="cover"
      />
    </div>
    <GradientWrapper className="absolute w-full h-full" />
    <div className="relative flex flex-wrap items-center justify-center w-full min-h-screen py-20">
      <Container>
        <Row>
          <Col xs={12} md={6}>
            <div className="flex justify-center h-full mb-24 md:items-center">
              <CrehanaLogos />
            </div>
          </Col>
          <Col
            xs={12}
            sm={8}
            md={6}
            lg={5}
            offset={{
              sm: 2,
              md: 0,
              lg: 0,
            }}
          >
            <div className="relative">
              {onBack && (
                <IconButton
                  className="absolute left-0 hidden -ml-72 sm:block"
                  isWhite
                  arrow="left"
                  onClick={onBack}
                />
              )}
              <FormWrapper className="px-20 py-24 rounded-10 lg:px-48 lg:py-48">
                {children}
              </FormWrapper>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  </StyledWrapper>
);

export default B2CLayout;
